import Clarity from "@microsoft/clarity";

const CLARITY_STATISTICS_CONSENT_KEY = "clarity_statistics_consent";
const DENIED_STATISTICS_CONSENT = "denied";
const GRANTED_STATISTICS_CONSENT = "granted";

let clarityInitialized = false;

const isBrowser = () => typeof window !== "undefined";

const isValidStatisticsConsent = (value) =>
  value === DENIED_STATISTICS_CONSENT || value === GRANTED_STATISTICS_CONSENT;

export const getStoredClarityStatisticsConsent = () => {
  if (!isBrowser()) {
    return null;
  }

  try {
    const consent = window.localStorage.getItem(CLARITY_STATISTICS_CONSENT_KEY);

    return isValidStatisticsConsent(consent) ? consent : null;
  } catch (error) {
    return null;
  }
};

export const setStoredClarityStatisticsConsent = (statisticsConsent) => {
  if (!isBrowser() || !isValidStatisticsConsent(statisticsConsent)) {
    return;
  }

  try {
    window.localStorage.setItem(
      CLARITY_STATISTICS_CONSENT_KEY,
      statisticsConsent
    );
  } catch (error) {
    return;
  }
};

const ensureClarityInitialized = () => {
  if (!isBrowser() || clarityInitialized) {
    return;
  }

  const clarityProjectId = import.meta.env.VITE_CLARITY_PROJECT_ID;

  if (!clarityProjectId) {
    return;
  }

  Clarity.init(clarityProjectId);
  clarityInitialized = true;
};

export const applyClarityStatisticsConsent = (
  statisticsConsent = DENIED_STATISTICS_CONSENT
) => {
  if (!isValidStatisticsConsent(statisticsConsent)) {
    return;
  }

  ensureClarityInitialized();

  if (!isBrowser() || typeof window.clarity !== "function") {
    return;
  }

  if (statisticsConsent === DENIED_STATISTICS_CONSENT) {
    window.clarity("consent", false);
  }

  window.clarity("consentv2", {
    ad_Storage: DENIED_STATISTICS_CONSENT,
    analytics_Storage: statisticsConsent,
  });
};

export const clarityStatisticsConsentValues = {
  denied: DENIED_STATISTICS_CONSENT,
  granted: GRANTED_STATISTICS_CONSENT,
};
